const inputTypeEnum = Object.freeze({
    TEXT: 5,
    SELECT: 10
});
export default inputTypeEnum;
